import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Link } from 'react-router-dom';

import {
  isGeoMotionVideo,
  isMaps,
  isIAS,
  isBoilerPlate,
  isLuminarias
} from '../../../modules/checkDeployEnv';

const { productName, homeLogoutLogo } = Meteor.settings.public;

const IAS_LOGO = '/ias-logo/ias.png';
const GMV_LOGO = `/ias-logo/${homeLogoutLogo}.png`;
const MAPS_LOGO = `/ias-logo/${homeLogoutLogo}.png`;
const BOILERPLATE_LOGO = '/ias-logo/srm.png';
const LUMINARIAS_LOGO = '/ias-logo/maps.png';

const ProductLogo = ({ deployEnv }) => {
  let appLogo = '';
  switch (true) {
    case isIAS(deployEnv):
      appLogo = IAS_LOGO;
      break;
    case isGeoMotionVideo(deployEnv):
      appLogo = GMV_LOGO;
      break;
    case isMaps(deployEnv):
      appLogo = MAPS_LOGO;
      break;
    case isBoilerPlate(deployEnv):
      appLogo = BOILERPLATE_LOGO;
      break;
    case isLuminarias(deployEnv):
      appLogo = LUMINARIAS_LOGO;
      break;
    default:
      break;
  }
  if (isGeoMotionVideo(deployEnv)) {
    return (
      <Link to="/dashboard">
        <img src={appLogo} alt={productName} />
      </Link>
    );
  }
  return (
    <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
      <img src={appLogo} alt={productName} style={{ width: '100%', maxWidth: 390 }} />
    </div>
  );
};

ProductLogo.defaultProps = {};

ProductLogo.propTypes = {
  deployEnv: PropTypes.string.isRequired
};

export default ProductLogo;
